import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This Haskell is wrong. Why?",
  "description": "",
  "published": "2012-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/this-haskell-is-wrong-why/swizec/3489"],
  "categories": "Games, Haskell, Programming, Puzzle, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-5-cube_scrambled2.png",
        "alt": "English: 5D virtual 3^5 sequential move puzzle...",
        "title": "English: 5D virtual 3^5 sequential move puzzle..."
      }}></img></p>
    <p>{`The problem I'm trying to solve is the simple but lovely `}<a parentName="p" {...{
        "href": "http://projecteuler.net/problem=62"
      }}>{`euler 62`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The cube, 41063625 (3453), can be permuted to produce two other cubes: 56623104 (3843) and 66430125 (4053). In fact, 41063625 is the smallest cube which has exactly three permutations of its digits which are also cube.`}</p>
      <p parentName="blockquote">{`Find the smallest cube for which exactly five permutations of its digits are cube.`}</p>
    </blockquote>
    <p>{`A bit of fun coding after a statistics midterm last night and the solution should be in the bag. Except it isn't, I am doing something wrong somehow and I can't figure out what! Hopefully someone a bit better than me can shed some light whether my proposed solution is wrong or I just suck at `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`.`}</p>
    <h2 {...{
      "id": "algorithm"
    }}>{`Algorithm`}</h2>
    <ol>
      <li parentName="ol">{`Generate cubes up to 10,000`}</li>
      <li parentName="ol">{`Every cube is a pair of a digit-ordered string `}<em parentName="li">{`n^3`}</em>{` and `}<em parentName="li">{`n, `}{`_`}{`for instance `}</em>{`("279",9)`}{`_`}</li>
      <li parentName="ol">{`Order cubes by the string number presentation`}</li>
      <li parentName="ol">{`Group together all cubes with the same `}<em parentName="li">{`n^3`}</em></li>
      <li parentName="ol">{`Pick out groups with the size of 5`}</li>
      <li parentName="ol">{`Sort by `}<em parentName="li">{`n`}</em></li>
      <li parentName="ol">{`Pick the smallest number`}</li>
    </ol>
    <p>{`Should work in principle right? So why doesn't the website accept my answer `}<em parentName="p">{`(5027)`}</em>{`? My guess is I'm doing something wrong in the sorting and grouping department and I was hoping someone with a bit more knowledge of Haskell could point out where I'm being stupid.`}</p>
    <h2 {...{
      "id": "code"
    }}>{`Code`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`import Data.List

cubes::(Num a) => a -> [(String, a)]
cubes 1 = [(show 1, 1)]
cubes n = (sort$show(n^3), n):(cubes $ n-1)

sortStrNum (s1, n1) (s2, n2)
  | length s1 == length s2 = compare s1 s2
  | otherwise = compare (length s1) (length s2)

permuted_cubes n =
  groupBy (\\a b -> fst a == fst b) $ sortBy sortStrNum $ cubes n

fives n =
  filter (\\xs -> length xs == 5) $ permuted_cubes n

comparing p x y = compare (p x) (p y)

smallest =
  head $ sortBy (comparing snd) $ head $ fives 100000
`}</code></pre>
    <p>{`The whole thing looks kind of alright to me, no matter how much I poke around it doesn't seem like something is misbehaving ... but it still is.`}</p>
    <p>{`Ideas?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/collatz-haskell-and-memoization/swizec/3382"
        }}>{`Collatz, Haskell and Memoization`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/learning-me-a-haskell/swizec/3272"
        }}>{`Learning me a Haskell`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8905037/converting-haskell-polymorphic-cosine-function-to-f"
        }}>{`Converting Haskell Polymorphic Cosine function to F#`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8155929/mutable-possibly-parallel-haskell-code-and-performance-tuning"
        }}>{`Mutable, (possibly parallel) Haskell code and performance tuning`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8275171/will-this-haskell-code-take-too-much-memory"
        }}>{`Will this Haskell code take too much memory?`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8751188/exceptions-in-haskell"
        }}>{`Exceptions in Haskell`}</a>{` (stackoverflow.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=727c4e4d-a97d-47a9-a6d5-d7017d2e3bfe",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      